// extracted by mini-css-extract-plugin
export default {"logo__container":"Header_logo__container__jghbS","logo__skeleton":"Header_logo__skeleton__MYWie","logo":"Header_logo__cGD8Y"};